module.exports = __webpack_public_path__ + "static/media/ic-bad-nor.ed9a1131.svg";